import { startLoading, stopLoading } from 'app/modules/cms/service/store/cms-dispatchs';
import { addCustomerEntry, setStepEngineCreatedClaim } from 'app/modules/step-engine/service/store/step-engine-dispatchs';
import { CustomerEntryName, Step } from 'app/modules/step-engine/utils/step-engine-constants';
import { NO, OTHER_OPTION, YES } from 'app/shared/constants/constants';
import { claimApi } from '../api/claim-api';
import { setClaim } from './store/claim-dispatch';
import { StepList } from 'app/modules/step-engine/service/store/step-engine-state';

export const generateParams = (data, cmsContent, stepList: StepList[]) => {
  const globalData = { ...data };
  globalData.comment = '';

  stepList.forEach(step => {
    const keyDataCamelCase = Step[step.stepName];
    const gtmLabel = cmsContent[keyDataCamelCase]?.prismic?.gtmLabel;
    const title = cmsContent[keyDataCamelCase]?.prismic?.title;
    const ignoreComment = cmsContent[keyDataCamelCase]?.behaviors?.ignoreComment ?? false;
    const ignore = ignoreComment === true || (ignoreComment instanceof Array && ignoreComment.includes(step.stepName));
    if (!ignore) {
      if (typeof globalData[keyDataCamelCase] === 'string') {
        // TODO : FIX string de type Date (code: "0", label: "Hier", value: "2021-11-03T12:26:18") on doit prendre value au lieu de label
        globalData.comment = globalData.comment.concat(title ? title : gtmLabel, ' ', globalData[keyDataCamelCase], '\n');
      } else if (globalData[keyDataCamelCase] instanceof Array) {
        let comment = '';
        comment = globalData[keyDataCamelCase]
          .map(item => {
            if (item.description) {
              return item.description;
            } else if (item.label) {
              if (item.values) {
                return item.label + ' ' + item.values.join(' - ');
              } else {
                return item.label;
              }
            } else {
              return item.value;
            }
          })
          .join(', ');
        globalData.comment = globalData.comment.concat(title, ' ', comment, '\n');
      } else if (globalData[keyDataCamelCase] instanceof Object) {
        globalData.comment = globalData.comment.concat(
          title,
          ' ',
          globalData[keyDataCamelCase].option ?
            globalData[keyDataCamelCase].option?.value === OTHER_OPTION ?
              globalData[keyDataCamelCase].otherOption
              :
              globalData[keyDataCamelCase].option?.label
            :
            globalData[keyDataCamelCase].description ?
              globalData[keyDataCamelCase].description
              : globalData[keyDataCamelCase].label
                ? globalData[keyDataCamelCase].label
                : globalData[keyDataCamelCase].name
                  ? globalData[keyDataCamelCase].name
                  : globalData[keyDataCamelCase].value,
          '\n'
        );
      }
    }
  })

  globalData.damagedGoodDate = data?.damagedGoodDate?.value;
  globalData.claimDeclarationDate = data?.claimDeclarationDate?.value;
  return globalData;
};

export const claimTransmit = (globalData, cmsContent, stepList) => async (dispatch) => {
  const params = generateParams(globalData, cmsContent, stepList);
  try {
    const response = await claimApi.claimTransmit(params);

    if (response.status === 200 || response.status === 201) {
      await dispatch(setClaim(response?.data));
      await dispatch(setStepEngineCreatedClaim(response?.data?.claimNumber));
      return response;
    } else {
      throw new Error('Creating Claim Error');
    }
  } catch (error) {
    throw new Error('Creating Claim Error');
  }
};

export const claimSherpaSimTransmit = (globalData, cmsContent, previousSteps) => async dispatch => {
  const params = generateParams(globalData, cmsContent, previousSteps);
  try {
    const response = await claimApi.claimSherpaSimTransmit(params);
    if (response.status === 200 || response.status === 201) {
      await dispatch(setClaim(response?.data));
      // await dispatch(setStepEngineCreatedClaim(response?.data));
      return response;
    } else {
      throw new Error('Creating Claim Error');
    }
  } catch (error) {
    console.error(error);
  }
};

export const uploadSherpaDocument = params => async dispatch => {
  try {
    const response = await claimApi.uploadSherpaDocument(params);
    if (response.status === 200 || response.status === 201) {
      return response;
    } else {
      throw new Error('Creating Document Error');
    }
  } catch (error) {
    console.error(error);
  }
};

export const workflowSherpaSimTransmit = params => async dispatch => {
  try {
    const response = await claimApi.workflowSherpaSimTransmit(params);
    if (response.status === 200 || response.status === 201) {
      await dispatch(setClaim(response?.data));
      return response;
    } else {
      throw new Error('Creating Workflow Error');
    }
  } catch (error) {
    console.error(error);
  }
};

export const getClaim = claimNumber => async dispatch => {
  await claimApi
    .getClaim(claimNumber)
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: 'claim/SET_CLAIM',
          payload: { trackingNumber: null, ...response.data },
        });
        return response;
      } else {
        return Promise.reject('Retrieving Claim Error');
      }
    })
    .catch(error => {
      return Promise.reject('Retrieving Claim Error');
    });
};

export const detectRefusal = (globalData, cmsContent, stepList) => async dispatch => {
  const params = generateParams(globalData, cmsContent, stepList);

  const response = await claimApi.detectRefusal(params);

  if (response.status === 200 || response.status === 201) {
    if (response.data === true) {
      await dispatch(addCustomerEntry(CustomerEntryName.REFUSAL_DETECTED, YES));
    } else {
      await dispatch(addCustomerEntry(CustomerEntryName.REFUSAL_DETECTED, NO));
    }
  } else {
    throw new Error('detect refusal Error'); //
  }
};

export const updateClaimDetails = data => async (dispatch, getState) => {
  const { claimNumber } = getState().claim;
  const claimDetailsDto: any = {
    claimNumber,
    details: data,
  };
  const response = await claimApi.updateClaimDetails(claimDetailsDto);
  if (response.status === 200 || response.status === 201) {
    return response;
  } else {
    throw new Error('update claim details Error');
  }
};

export const modifyClaim = (payload: any) => dispatch => {
  dispatch({
    type: 'claim/SET_CLAIM',
    payload,
  });
};
